// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a7ca0029","34":"397373d9","107":"c1d4aad3","130":"dae59195","143":"47cd7df6","257":"31947673","358":"28e76e8a","404":"fa926549","456":"0f6f72ca","601":"d2987ebe"}[chunkId] + ".chunk.js";
};